<template>
  <div class="outlets-picker-wrapper">
    <input-select
      :ref="ref"
      :name="ref"
      :classNames="`datatable-input-select datatable-input-select--fixed ${loading ? 'loading' : ''}`"
      placeholder="Search an outlet"
      :options="availableOptions"
      :selectedValue="value"
      :searchable="true"
      :allowEmpty="false"
      :onOpen="onOpen"
      :onSearchChange="onSearchChange"
      :loading="loading"
      :onChange="onChangeInput"
      :showNoResults="false"
      :internalSearch="false"
      :disabled="true"
    >
      <template slot="custom" scope="props">
        <div class="option">{{ props.scope.option.label }}</div>
      </template>
      <template slot="beforeListCustom">
        <li v-if="options.length == 0" class="empty-outlets">Type to search</li>
      </template>
    </input-select>
  </div>
</template>

<script>
import _ from "lodash";
import InputSelect from "./form-components/input-select";

export default {
  props: {
    fetchOutlets: Function,
    onChange: Function,
    options: Array
  },

  data: function() {
    const availableOptions = [...this.options];

    let value = null;

    if (this.$attrs.getProps() != undefined) {
      const outletId = this.$attrs.getProps().outlet_id;
      value = outletId;
    }

    return {
      ref: "outlets-picker-" + Math.round(Math.random() * 10000),
      value,
      search: "",
      loading: false,
      availableOptions,
      timeout: null
    };
  },

  mounted() {
    
    // this.fetch();
  },

  methods: {
    fetch: function() {
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = null;

      this.timeout = setTimeout(() => {
        this.fetchOutlets(this.search, this.value).then(res => {
          const data = res;
          this.availableOptions = data.map(d => ({
            value: d.id,
            label: d.name
          }));

          this.$nextTick(() => {
            this.$refs[this.ref].setPosition();
          });

          this.loading = false;
        });
      }, 300);
    },

    onOpen: function() {},

    onSearchChange: function(value) {
      this.search = value;
      if (this.search != "") {
        this.fetch();
      }
    },

    onChangeInput: function(value) {
      this.onChange(value);
    }
  },

  components: {
    InputSelect
  }
};
</script>

<style lang="scss" scoped>
.empty-outlets {
  padding: 12px;
}
</style>